
import { BUSINESS_UNIT_METADATA } from '../../businessunit/model/business-unit.metadata';
import { COST_CENTRE_METADATA } from '../../costcentre/model/cost-centre.metadata';
import { EntityMetadata, GenericEntityMetadata, PropertyMetadata, RelationshipType, TemporalType, nullIfContainsNull } from '@scisys-uim/uim-common';


export class RangerSourceMapMetadataBase extends GenericEntityMetadata {
  constructor() {
    super('RangerSourceMap', {
      rangerSourceMapId: <PropertyMetadata> {
        name: 'rangerSourceMapId',
        type: 'string',
        plural: false,
        isIdentity: true,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      businessUnits: <PropertyMetadata> {
        name: 'businessUnits',
        type: 'BusinessUnit',
        plural: true,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        relationship: true,
        relationshipType: RelationshipType.ManyToMany,
        get relationshipEntityMetadata(): EntityMetadata {
          return BUSINESS_UNIT_METADATA;
        },
        byReference: true,
        unique: false
      },
      costCentres: <PropertyMetadata> {
        name: 'costCentres',
        type: 'CostCentre',
        plural: true,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        relationship: true,
        relationshipType: RelationshipType.ManyToMany,
        get relationshipEntityMetadata(): EntityMetadata {
          return COST_CENTRE_METADATA;
        },
        byReference: true,
        unique: false
      },
      businessUnitIds: <PropertyMetadata> {
        name: 'businessUnitIds',
        type: 'string',
        plural: true,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: true,
        readable: true,
        writeable: false,
        length: 255,
        unique: false
      },
      costCentreIds: <PropertyMetadata> {
        name: 'costCentreIds',
        type: 'string',
        plural: true,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: true,
        readable: true,
        writeable: false,
        length: 255,
        unique: false
      },
      rangerEmail: <PropertyMetadata> {
        name: 'rangerEmail',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      rangerExists: <PropertyMetadata> {
        name: 'rangerExists',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      rangerId: <PropertyMetadata> {
        name: 'rangerId',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      sourceEmail: <PropertyMetadata> {
        name: 'sourceEmail',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      sourceExists: <PropertyMetadata> {
        name: 'sourceExists',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      sourceId: <PropertyMetadata> {
        name: 'sourceId',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      sourceName: <PropertyMetadata> {
        name: 'sourceName',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      sourceValid: <PropertyMetadata> {
        name: 'sourceValid',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      sourceValidByDate: <PropertyMetadata> {
        name: 'sourceValidByDate',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      sourceValidFrom: <PropertyMetadata> {
        name: 'sourceValidFrom',
        type: 'Date',
        temporalType: TemporalType.DATE,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      sourceValidRangerEmail: <PropertyMetadata> {
        name: 'sourceValidRangerEmail',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      sourceValidTo: <PropertyMetadata> {
        name: 'sourceValidTo',
        type: 'Date',
        temporalType: TemporalType.DATE,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      }
    });
  }
  toKeyObject(item: any): any {
    const result = item?.rangerSourceMapId;
    return nullIfContainsNull(result);
  }
}



